<template>
  <modal-card v-if="ctrl.active" :ctrl="ctrl">
    <div slot="body" class="">
      <div v-html="text" v-show="text" class="has-text-centered is-text-rlarge"></div>
      <div v-if="!selected" class="buttons is-multiline">
        <button
            v-for="branch in message.data.branches"
            class="button is-white"
            :class="{'is-visited': isSelected(branch)}"
            @click="next(branch)">
          <v-color-icon :size="24" class="is-text-link" name="arrow-right"></v-color-icon>
          <span>{{ branch.text }}</span>
        </button>
      </div>
    </div>
  </modal-card>
</template>

<script>
import IClassroom from '@/components/classroom/lib/IClassroom'
import { MessageType } from '@/components/classroom/lib/Message'
import _ from 'lodash'

export default {
  props: ['message'],
  data () {
    return {
      selected: null,
      ctrl: { active: false, force: true, noHeader: true, noFooter: true }
    }
  },
  computed: {
    text () {
      if (this.message.data.text) {
        let text = this.message.data.text
        text = text.replace(/{\s*name\s*}/g, IClassroom.user.name)
        return text
      }
      return ''
    }
  },
  mounted () {
    setTimeout(() => {
      this.ctrl.active = true
    }, 1000)
  },
  methods: {
    next (branch) {
      this.selected = branch
      this.ctrl.active = false
      this.ctrl.force = false

      const msg = IClassroom.createMessage('self', MessageType.TEXT, { text: branch.text })
      IClassroom.$emit('message', msg)
      IClassroom.requestNextMessage(300, branch.next)
    },
    isSelected (branch) {
      return !!_.find(IClassroom.courseMessages, { id: branch.next })
    }
  }
}
</script>

<style lang="stylus" scoped>
.text-message {
  max-width 800px
}

.buttons {
  display block
  margin .5rem auto 2rem auto
  width fit-content
}

.button {
  display flex
  width fit-content

  &.is-visited {
    opacity .3
  }

  &:hover {
  }
}
</style>
